import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Type from './customertype';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import { Form, TextArea, Button, Grid } from 'semantic-ui-react'
import View from './view';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import Template from './templates';

class Multiple extends React.Component {

  state = {
    allCustomer: [],
    primarycheckBox: true,
    secoundarycheckBox: true,
  }

  componentDidMount() {
    this.getCustomer();
  }

  getCustomer() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Customer type'
    })
    $.ajax({
      type: 'POST',
      url: Server() + 'customer/getallcustomer.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setState({
            allCustomer: data
          })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  getCount(data) {
    let primaryNumbers = 0;
    let secoundaryNumbers = 0;
    data.map((x) => {
      try {
        if (x.mobile.length >= 9) {
          primaryNumbers = primaryNumbers + 1;
        }
        if (x.altmobile.length >= 9) {
          secoundaryNumbers = secoundaryNumbers + 1;
        }
      } catch (e) {

      }
    })
    this.setState({
      primaryNumbersCount: primaryNumbers,
      secoundaryNumbersCount: secoundaryNumbers
    })
  }

  update(type, value, data) {
    let context = this;
    if (value == 'All') {
      let items = [];
      let customers = this.state.allCustomer;
      customers.map((z) => {
        if (z.mobile || z.alt_mobile) {
          items.push({ id: z.id, name: z.name, mobile: z.mobile, altmobile: z.alt_mobile, taluk: z.taluk, type: z.type })
        }
      })
      this.getCount(items);
      this.setState({ data: items })
    }
    else {
      let customerTypeId = 0;
      data.map((z)=> {
        if (value == z.type_name) {
          customerTypeId = z.id;
        }
      })
      let items = [];
      let customers = this.state.allCustomer;
      customers.map((z) => {
        if (z.type == customerTypeId) {
          if (z.mobile || z.alt_mobile) {
            items.push({ id: z.id, name: z.name, mobile: z.mobile, altmobile: z.alt_mobile, taluk: z.taluk, type: z.type })
          }
        }
      })
      this.getCount(items);
      this.setState({ data: items })
    }
  }

  remove(value) {
    let data = this.state.data;
    let items = [];
    data.map((z) => {
      if (value == z.mobile) {

      }
      else {
        items.push(z);
      }
    })
    this.setState({ data: items })
  }

  send() {
    let context = this;
    let message = this.state.messages;
    let items = this.state.data;
    let data = [];
    let primarycheckBox = this.state.primarycheckBox;
    let secoundarycheckBox = this.state.secoundarycheckBox;
    items.map((z) =>{
      if (primarycheckBox == true && secoundarycheckBox == true) {
        if (z.altmobile == z.mobile) {
          data.push({ mobile: z.altmobile })
        }
        else {
          if (z.altmobile) {
            data.push({ mobile: z.altmobile })
          }
          if (z.mobile) {
            data.push({ mobile: z.mobile })
          }
        }
      }
      else if (primarycheckBox == true) {
        if (z.mobile) {
          data.push({ mobile: z.mobile })
        }
      }
      else if (secoundarycheckBox == true) {
        if (z.altmobile) {
          data.push({ mobile: z.altmobile })
        }
      }
    });
    if (data.length <= 0) {
      alert('Select the Customer or Select Checkbox');
      return;
    }
    if (message == '' || message == undefined || message == null) {
      alert('Enter the message')
      return;
    }
    data = JSON.stringify(data);
    let data1 = { 'data': data, 'message': message };
    context.setState({
      load: true,
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'sms/send.php',
      success: function(data)
      {
        alert('Message Send Successfully!!!!')
        context.setState({ load: false, messages: '' })
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  updateData(data) {
    this.setState({
      data: data
    })
  }

  handleChange = (name) => event => {
    this.setState({ [name]: event.target.checked })
  }

  template(template) {
    this.setState({ messages: template })
  }

  render() {
    return (
      <div  style={{height: 700, padding: '1%', display: this.props.viewcontrol}}>
        <Loading load={this.state.load} message={'Sending sms!!!'} />
        <Type update={this.update.bind(this)} />
        <br/>
        { this.state.data ?
          (
            <Grid>
              <Grid.Column mobile={8} tablet={8} computer={6}>
                <Paper>
                  <MenuList id="scrolls">
                    <View updateData={this.updateData.bind(this)}
                          data={this.state.data} />
                  </MenuList>
                </Paper>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={10}>
                  <div style={{display: 'flex'}}>
                  <Checkbox onChange={this.handleChange('primarycheckBox')}
                    checked={this.state.primarycheckBox} /><br/>Primary Numbers{'('+this.state.primaryNumbersCount+')'}
                  <Checkbox onChange={this.handleChange('secoundarycheckBox')}
                    checked={this.state.secoundarycheckBox} /><br/>Secoundary Number{'('+this.state.secoundaryNumbersCount+')'}
                  </div>
                    <Form>
                      <TextArea rows={10} onChange={e => this.setState({ messages: e.target.value })}
                       value={this.state.messages}
                       placeholder='Enter the message' />
                    </Form>
                    <Template template={this.template.bind(this)} />
                    <br/>
                    <center>
                    {
                      this.props.menuPermission.add ?
                      <Button primary onClick={this.send.bind(this)}>Send</Button>: ''
                    }
                  </center>
              </Grid.Column>
            </Grid>
          ) :
          (
            <div></div>
          )
        }
      </div>
    );
  }
}

export default Multiple;
